export const normal_frag_params = `
varying vec3 vNormal;
`;